import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { IAnnotationUiStore } from '../../annotation/annotationUi.store';
import { Image } from '../../annotation/components/Image';
import { DrawingContainer } from '../../annotation/containers/Drawing.container';
import { IAttachmentsPreviewService } from '../attachmentsPreview.service';

export const AttachmentImagePreviewContainer = observer((): ReactElement => {
  const annotationUiStore = useInjection(IAnnotationUiStore.$);
  const previewService = useInjection(IAttachmentsPreviewService.$);
  const [currentZoom, setCurrentZoom] = useState(100);

  const handleZoomChanged = (zoom: number): void => {
    setCurrentZoom(zoom);
  };

  const handleLowResImageLoaded = (): void => {
    previewService.data.isPreviewImageLoading = false;
  };

  const data = previewService.data;

  return (
    <div className='attachment-image-preview'>
      <Image
        isLeftMenuOpened={false}
        isLoading={data.isPreviewImageLoading}
        isHighResImageLoading={!data.imagePreviewUrl}
        url={data.imagePreviewUrl || ''}
        lowQualityUrl={data.lowQualityImagePreviewUrl || ''}
        height={data.imageInfo.height || 0}
        width={data.imageInfo.width || 0}
        zoomLevel={currentZoom}
        minZoomLevel={annotationUiStore.minZoomLevel}
        maxZoomLevel={annotationUiStore.maxZoomLevel}
        onZoomChanged={handleZoomChanged}
        onLowResImageLoaded={handleLowResImageLoaded}
      >
        <DrawingContainer disableCursorGuides={false} />
      </Image>
    </div>
  );
});
